import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@base-app';
import {
  CollapseIcon,
  ExpandIcon,
  StyledCollapseContent,
  StyledCollapsibleContainer,
  StyledCollapsibleSectionContainer,
  StyledSectionTitle,
  StyledTitle,
} from './CollapsibleSection.styles';
import { CollapsibleSectionProps } from './CollapsibleSection.types';
import { COMMON_TRANSLATION } from '@/common/constants';
import { Variants } from '@/common/types';
const CollapsibleSection: FC<CollapsibleSectionProps> = ({
  children,
  css,
  cssTitle,
  id,
  isCollapsed = false,
  title,
  variant = Variants.PRIMARY,
}) => {
  const { t } = useTranslation(COMMON_TRANSLATION);
  const [collapse, setCollapse] = useState<boolean>(isCollapsed);
  const expandId = id ? `collapsible-section-expand-${id}` : `collapsible-section-expand`;
  const collapseId = id ? `collapsible-section-collapse-${id}` : `collapsible-section-collapse`;
  const toggleCollapse = (): void => {
    setCollapse(!collapse);
  };
  return (
    <StyledCollapsibleSectionContainer css={{ ...css }} isCollapsed={collapse} variant={variant}>
      {
        <StyledSectionTitle css={{ ...cssTitle }} isCollapsed={collapse} variant={variant}>
          <StyledTitle data-testid="collapsible-section-title" isCollapsed={collapse} variant={variant}>
            {title ?? ''}
          </StyledTitle>
          <StyledCollapsibleContainer data-testid="collapsible-section-collapsible" onClick={toggleCollapse}>
            {collapse ? (
              <StyledCollapseContent data-testid={expandId}>
                {t('section.expand')}
                <ExpandIcon />
              </StyledCollapseContent>
            ) : (
              <StyledCollapseContent data-testid={collapseId}>
                {t('section.collapse')}
                <CollapseIcon />
              </StyledCollapseContent>
            )}
          </StyledCollapsibleContainer>
        </StyledSectionTitle>
      }
      {!collapse && <Box data-testid="collapsible-section-content">{children}</Box>}
    </StyledCollapsibleSectionContainer>
  );
};
export default CollapsibleSection;
